import { axiosInstance } from "helpers";

export async function generalSettingShow(website_id) {
  return axiosInstance
    .get("allfeaturesettings", {
      params: {
        api_key: localStorage.getItem("apikey"),
        added_by: localStorage.getItem("user_id"),
        tab_hint: "General",
        website_id,
      },
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err.response.data;
    });
}

export async function generalSettingUpdate(params) {
  return axiosInstance
    .post("updatefeaturesettings", {
      ...params,
      api_key: localStorage.getItem("apikey"),
      added_by: localStorage.getItem("user_id"),
      tab_hint: "General",
      system_status: 0,
    })
    .then((res) => res.data)
    .catch((err) => {
      throw err.response.data;
    });
}
